import React, { useState } from "react";
import { Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LoadingButton } from '@mui/lab'
import { useSnackbar } from 'notistack';
import { useTranslation } from "react-i18next";
import { deleteOvertime } from "utils/Overtime";

const DeleteOvertime = ({ open, setOpen, selectedRow, reloading }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [loadingInfoOvertime, setLoadingInfoOvertime] = useState(false);

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth={"md"}
        >
            <DialogTitle>{t("settings.overtimes.titles.delete")}</DialogTitle>
            <DialogContent>
                <Typography>{t('settings.overtimes.alerts.delete.message')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="error" onClick={() => setOpen(false)}>{t('general.buttons.cancel')}</Button>
                <LoadingButton
                    variant='contained'
                    disabled={loadingInfoOvertime}
                    onClick={() => {
                        deleteOvertime(setLoadingInfoOvertime, selectedRow[0])
                        .then((response) => {
                            console.log(response);
                            setOpen(false)
                            enqueueSnackbar(t('settings.overtimes.alerts.delete.success'), { variant: 'success' });
                            reloading()
                        })
                        .catch((error) => {
                            console.error(error);
                            enqueueSnackbar(t('settings.overtimes.alerts.delete.error'), { variant: 'error' });
                        });
                    }}
                >{t("general.buttons.delete")}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

export { DeleteOvertime };